import { HisInformationItem } from "./HisInformationItem";
import { IHisInformationBean } from "../../infrastructure/his/ver2/beans/IHisInformationBean";
import { Table } from "../system/table";
import { DepartmentRelatedHisInformation, HisInformationProcessResult, VisitHistoryInformation } from ".";
import { HospitalizationHistoryInformation } from "./HospitalizationHistoryInformation";

/**
 * HisInfoGetterで取得した情報
 */
export class HisInformation {
  diseaseItems: HisInformationItem[] = [];
  hospitalizationItems: HisInformationItem[] = [];
  operationItems: HisInformationItem[] = [];
  managerIds: string[] = null;
  hospitalizationAdditionalCollection: Table = null;

  constructor(
    public items: HisInformationItem[],
    public diseaseCollection: Table,
    public hospitalizationCollection: Table,
    public operationCollection: Table,
    public visitHistories: VisitHistoryInformation[],
    public hospitalizationHistories: HospitalizationHistoryInformation[],
    public departmentRelatedInformations: DepartmentRelatedHisInformation[],
    public processResult: HisInformationProcessResult,
    public origin: IHisInformationBean,
  ) {
  }
}
